import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  Button,
  Glyphicon,
  Accordion,
  Panel
} from 'react-bootstrap';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { ToastContainer, toast } from 'react-toastify';
import { css } from 'glamor';
import ErrorAlert from '../utils/ErrorAlert';
import request from '../../utils/Request';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorMessage: '',
      documents: [],
      property: [],
      categories: [],
      staff: [],
      agent: {}
    };

    this.compare = (a, b) => {
      const alpha = a.title;
      const beta = b.title;
      if (alpha < beta) {
        return 1;
      }
      if (alpha > beta) {
        return -1;
      }
      return 0;
    };

    this.icon = (header) => (
      <div>
        {header}{' '}
        <Glyphicon
          glyph="glyphicon glyphicon-plus"
          style={{ float: 'right' }}
        />
      </div>
    );
  }

  componentDidMount() {
    this.loadProperty();
    this.loadCatagories();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.property !== this.state.property) {
      this.loadAgent();
      this.loadStaff();
      this.loadDocuments(this.state.property.id);
    }
  }

  getCategory(id) {
    const { categories } = this.state;
    if (categories === undefined || categories.length === 0) {
      return id;
    }
    let name = id;
    categories.forEach((category) => {
      if (category.id === id) name = category.name;
    });
    return name;
  }

  loadStaff() {
    request
      .get(`/stratapropertystaff/property/${this.state.property.id}`)
      .then((staff) => {
        this.setState({
          staff
        });
      })
      .catch(() => {
        toast('Could not load staff.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: css({
            background: 'black'
          })
        });
      });
  }

  loadAgent() {
    request
      .get(`/strataAgent/${this.state.property.agentId}`)
      .then((res) => {
        this.setState({ agent: res });
      })
      .catch(() => {
        toast('Could not load agent.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: css({
            background: 'black'
          })
        });
      });
  }

  loadCatagories() {
    request
      .get('/StrataDocumentCategories/all')
      .then((categories) => {
        this.setState({
          categories
        });
      })
      .catch(() => {
        toast('Could not load categories.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: css({
            background: 'black'
          })
        });
      });
  }

  loadProperty() {
    request
      .get(`/StrataProperty/propertyAdmin/${localStorage.user_id}`)
      .then((property) => {
        this.setState({
          property
        });
      })
      .catch(() => {
        toast('Could not load property.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: css({
            background: 'black'
          })
        });
      });
  }

  loadDocuments(id) {
    request
      .get(`/stratadocuments/property/${id}`)
      .then((documents) => {
        this.setState({ documents, error: false });
      })
      .catch(() => {
        toast('Could not load Documents.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: css({
            background: 'black'
          })
        });
      });
  }

  showDocument(id) {
    this.props.history.push({
      pathname: `/propertyAdmin/document/view/${id}`
    });
  }

  generatePanels() {
    const { categories, documents } = this.state;

    return categories.map((c) => {
      const catDocs = [];
      documents.forEach((d) => {
        if (c.id === d.strataDocumentCategoryId) {
          catDocs.push({ ...d, title: d.title || 'No File Name' });
        }
      });
      catDocs.sort(this.compare);
      if (catDocs.length > 0) {
        return (
          <div>
            <Grid>
              <Row>
                <Col md={12}>
                  <Accordion>
                    <Panel header={this.icon(c.name)} eventKey="1">
                      {catDocs.map((d) => (
                        <Grid>
                          <Row
                            id={d.id}
                            style={{
                              clear: ' both',
                              overflow: 'hidden',
                              paddingRight: '40px'
                            }}>
                            <Col md={6}>
                              <p style={{ fontSize: '16px' }}>
                                <a
                                  href={`${process.env.REACT_APP_SITE_API}/api/stratadocuments/${d.id}/file`}>
                                  {d.title}
                                </a>
                              </p>
                            </Col>
                            <Col md={6}>
                              <Button
                                bsSize="small"
                                bsStyle="info"
                                style={{
                                  marginRight: 5,
                                  marginLeft: 5,
                                  float: 'right'
                                }}
                                onClick={() => {
                                  this.showDocument(d.id);
                                }}>
                                <Glyphicon glyph="eye-open" />
                              </Button>
                              <Button
                                bsSize="small"
                                bsStyle="success"
                                style={{
                                  marginRight: 5,
                                  marginLeft: 5,
                                  float: 'right'
                                }}
                                href={`${process.env.REACT_APP_SITE_API}/api/stratadocuments/${d.id}/file`}>
                                <Glyphicon glyph="download-alt" />
                              </Button>
                            </Col>
                          </Row>
                        </Grid>
                      ))}
                    </Panel>
                  </Accordion>
                </Col>
              </Row>
            </Grid>
          </div>
        );
      }
      return null;
    });
  }

  loadStaffInfo() {
    const s = this.state.staff;
    if (s === undefined || s.length === 0) {
      return (
        <p style={{ marginBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>No Building Staff </span>
        </p>
      );
    }
    return s.map((staff) => {
      const daysArray = staff.hours.split(',');
      return (
        <Col md={6}>
          <Panel style={{ marginBottom: 5 }} id={staff.id}>
            <h4>{staff.position}</h4>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Name : </span>
              {staff.name}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Phone : </span>
              <a href={`tel:${staff.phone}`}>{staff.phone}</a>
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Email : </span>
              <a href={`mailto:${staff.email}`}>{staff.email}</a>
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Monday: </span>
              {daysArray[0]}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Tuesday: </span>
              {daysArray[1]}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Wednesday: </span>
              {daysArray[2]}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Thursday: </span>
              {daysArray[3]}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Friday: </span>
              {daysArray[4]}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Saturday: </span>
              {daysArray[5]}
            </p>
            <p style={{ marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>Sunday: </span>
              {daysArray[6]}
            </p>
          </Panel>
        </Col>
      );
    });
  }

  render() {
    return (
      <div>
        <ToastContainer />
        <section className="section m-none">
          <div>
            <Grid>
              <Row>
                <Col md={12}>
                  <h3 style={{ marginBottom: 15 }}>
                    Strata Plan {this.state.property.strataPlanNumber} -{' '}
                    {this.state.property.buildingName} ||{' '}
                    {this.state.property.address}
                  </h3>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Panel header="Building Details">
                    <p style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: 'bold' }}>
                        Building Name :{' '}
                      </span>
                      {this.state.property.buildingName}
                    </p>
                    <p style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: 'bold' }}>Strata Plan : </span>
                      {this.state.property.strataPlanNumber}
                    </p>
                    <p style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: 'bold' }}>
                        Building Address :{' '}
                      </span>
                      {this.state.property.address}
                    </p>
                  </Panel>
                </Col>
                <Col md={6}>
                  <Panel header="Strata Agent">
                    <p style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: 'bold' }}>Agent Name : </span>
                      {this.state.agent.name}
                    </p>
                    <p style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: 'bold' }}>Agent Phone : </span>
                      <a href={`tel:${this.state.agent.phone}`}>
                        {this.state.agent.phone}
                      </a>
                    </p>
                    <p style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: 'bold' }}>Agent Email : </span>
                      <a href={`mailto:${this.state.agent.email}`}>
                        {this.state.agent.email}
                      </a>
                    </p>
                  </Panel>
                </Col>
              </Row>
              <Accordion>
                <Panel header={this.icon('Onsite Staff')} eventKey="3">
                  {this.loadStaffInfo()}
                </Panel>
              </Accordion>
              <h3 style={{ marginBottom: 15 }}>Documents</h3>
            </Grid>
            {this.generatePanels()}
          </div>
          <Row>
            {this.state.error ? (
              <ErrorAlert errorMessage={this.state.errorMessage} />
            ) : null}
          </Row>
        </section>
      </div>
    );
  }
}

export default Dashboard;
